import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { config } from "../../constants/domainConfig";
import { Container, Row, Col, Button, Form, Input } from "reactstrap";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { FormattedMessage } from "react-intl";
import { console_log } from "../../utils/helper";

class StaticPages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "",
    };
  }

  componentWillMount() {
    switch (this.props.location.pathname) {
      case "/about":
        this.props.setHeaderTitle("About Us");
        this.setState({
          type: "about",
        });
        break;
      case "/privacy-policy":
        if (config.lang == "no") {
          this.props.setHeaderTitle("PERSONVERNPOLICY");
        } else if (config.subDomain == "tr") {
          this.props.setHeaderTitle("Gizlilik Politikası");
        } else {
          this.props.setHeaderTitle("Privacy Policy");
        }
        this.setState({
          type: "privacy-policy",
        });
        break;
      case "/terms-conditions":
        this.props.setHeaderTitle("Terms And Conditions");
        this.setState({
          type: "terms-conditions",
        });
        break;
    }
    this.props.show();
    setTimeout(() => {
      this.props.hide();
    }, 1000);
  }

  componentDidMount() {
    if (config.useMobiofitTheme) {
      document.body.classList.add("gradient-bg-mobiofit");
    } else {
      document.body.classList.add("gradient-bg");
    }

    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    switch (nextProps.location.pathname) {
      case "/about":
        nextProps.setHeaderTitle("About Us");
        this.setState({
          type: "about",
        });
        break;
      case "/privacy-policy":
        if (config.lang == "no") {
          nextProps.setHeaderTitle("PERSONVERNPOLICY");
        } else if (config.lang == "ar") {
          nextProps.setHeaderTitle("سياسة الخصوصية");
        } else if (config.subDomain == "sn") {
          nextProps.setHeaderTitle("Politique de confidentialité");
        } else if (config.subDomain == "ee") {
          nextProps.setHeaderTitle("Privaatsuse õigused");
        } else if (config.subDomain == "tr") {
          nextProps.setHeaderTitle("Gizlilik Politikası");
        } else if (config.subDomain == "lv") {
          nextProps.setHeaderTitle("Privātuma politika");
        } else if (config.subDomain == "lt") {
          nextProps.setHeaderTitle("Privatumo politika");
        } else if (config.subDomain == "rs") {
          nextProps.setHeaderTitle("Приватност");
        } else if (config.subDomain == "th") {
          nextProps.setHeaderTitle("นโยบายความเป็นส่วนตัว");
        } else if (config.subDomain == "gr") {
          nextProps.setHeaderTitle("ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ");
        } else if (config.subDomain == "ch") {
          nextProps.setHeaderTitle("DATENSCHUTZRECHTE");
        } else if (config.lang == "fr") {
          nextProps.setHeaderTitle("Politique de confidentialité");
        } else if (config.lang == "cs") {
          nextProps.setHeaderTitle("ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ");
        } else if (config.lang === "es") {
          nextProps.setHeaderTitle("Política de privacidad");
        } else if (config.lang === "pt") {
          nextProps.setHeaderTitle("Política de Privacidade");
        } else {
          nextProps.setHeaderTitle("Privacy Policy");
        }
        this.setState({
          type: "privacy-policy",
        });
        break;
      case "/terms-conditions":
        nextProps.setHeaderTitle("Terms And Conditions");
        if (config.subDomain == "rs") {
          nextProps.setHeaderTitle("Услови коришћења");
        }
        this.setState({
          type: "terms-conditions",
        });
        break;
    }
    if (this.props.location.pathname != nextProps.location.pathname) {
      this.props.show();
      setTimeout(() => {
        this.props.hide();
      }, 500);
    }
  }

  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.body.classList.remove("gradient-bg");
    document.body.classList.remove("gradient-bg-mobiofit");
  }

  __getAboutUsPage() {
    return (
      <section className="about">
        <div className="about-inner">
          <Container fluid>
            <Row className="text-center">
              <Col xs="12">
                <div className="logo-wrap">
                  {config.title == "bidiotv" &&
                  config.mainDomain != "mobiotv" ? (
                    <img
                      className="img-fluid"
                      src="./img/logo/bidiotv-logo.png"
                      alt="BidioTV"
                    />
                  ) : (
                    <img
                      className="img-fluid"
                      src="./img/logo.png"
                      alt="MobioTV"
                    />
                  )}
                </div>
                {config.title == "bidiotv" && config.mainDomain != "mobiotv" ? (
                  <p className="basic-para">
                    Our Story is about Over-The-Top Content (OTT). BidioTV is a
                    Video-On-Demand (VOD) Streaming site provides the most
                    incredible movies, videos and TV channels worldwide to any
                    connected device. Select your TV and VOD to enjoy our
                    international, local and thematic TV channels and On Demand
                    Videos that enrich every subscriber’s need.
                  </p>
                ) : (
                  <p className="basic-para">
                    Our Story is about Over-The-Top Content (OTT). MobioTV is a
                    TV Channel and Video-On-Demand (VOD) Streaming site provides
                    the most incredible movies, videos and TV channels worldwide
                    to any connected device. Select your TV and VOD to enjoy our
                    international, local and thematic TV channels and On Demand
                    Videos that enrich every subscriber’s need.
                  </p>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    );
  }

  __getPrivacyPolicy() {
    let termTitleClass =
      config.subDomain == "iq" || config.subDomain == "ae.mobioviewtv"
        ? "terms-title arabic"
        : "terms-title";
    return (
      <section className="terms-conditions">
        {config.subDomain === "rs" ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>Politika privatnosti</h6>
                <p className="terms-para">
                  Ova stranica vas informiše o našim politikama u vezi sa
                  prikupljanjem, korišćenjem i objavljivanjem ličnih informacija
                  koje primamo od korisnika veb lokacije. Koristimo vaše lične
                  informacije samo zarad dostavljanja pristupa na veb lokaciju.
                  Kada koristite veb lokaciju, slažete se oko prikupljanja i
                  korišćenja informacija u skladu sa ovom politikom.
                  Prikupljanje informacije i korišćenje dok koristite ovu veb
                  lokaciju, možemo da tražimo od vas da nam dostavite određene
                  informacije koje vas lično identifikuju a koje mogu da se
                  koriste da bismo vas kontaktirali ili identifikovali. Lične
                  informacije o identifikaciji mogu da uključuju, ali nisu
                  ograničene na vaše ime („lične informacije“).
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>Podaci o upisivanju </h6>
                <p className="terms-para">
                  Kao većina operatera veb lokacija, prikupljamo informacije
                  koje vaš pretraživač šalje kadagod posetite našu veb lokaciju
                  („podaci o upisivanju“). Ovi podaci o upisivanju mogu da
                  uključuju informacije kao što su broj mobilnog telefona
                  (MSISDN), tip pretraživača, verzija pretraživača, strane naše
                  veb lokacije koju ste posetili, vreme i datum vaše posete,
                  vreme provedeno na ovim stranicama i drugu statistiku. Pored
                  toga, možemo da koristimo usluge treće strane kao što su
                  Google Analytics koje prikupljanju, kontrolišu i analiziraju
                  ovo.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>Kolačići </h6>
                <p className="terms-para">
                  Kolačići su datoteke sa manjom količinom podataka, koji mogu
                  da uključuju anonimni jedinstveni identifikator. Kolačići se
                  šalju na vaš pretraživač sa veb lokacije i čuvaju na hard
                  drajvu vašeg računara. Kao većina veb lokacija, koristimo
                  „kolačiće“ da prikupljamo informacije. Možete da obavestite
                  svoj pretraživač da odbije sve kolačiće ili da navedete kada
                  se kolačići šalju. Međutim, ako ne prihvatite kolačiće, možda
                  nećete moći da koristite neke delove naše veb lokacije.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>Bezbednost</h6>
                <p className="terms-para">
                  Bezbednost vaših ličnih informacija nam je važna, ali setite
                  se da nijedan metod prenosa preko interneta, ili metod
                  elektronskog skladištenja, nije 100% bezbedan. Iako se trudimo
                  da koristimo komercijalno prihvatljive načine da zaštitmo vaše
                  lične informacije, ne možemo da garantujemo njihovu potpunu
                  bezbednost. Izmene nad ovom politikom privatnosti Ova politika
                  privatnosti je na snazi od datuma vaše pretplate na uslugu i
                  ostaće na snazi bez obzira na bilo koje promene u odredbama u
                  budućnosti, koje će odmah stupiti na snagu nakon što se objave
                  na ovoj strani. Zadržavamo pravo da ažuriramo ili promenimo
                  našu politiku privatnosti bilo kada i treba da proverite ovu
                  politiku privatnosti periodično. Vaše neprekidno korišćenje
                  usluge nakon što objavimo bilo kakve izmene nad politikom
                  privatnosti na ovoj strani smatraće se vašim prihvatanjem
                  izmena i vašu saglasnost da ih poštujete putem izmenjene
                  politike privatnosti. Ako izvršimo bilo kakve materijalne
                  izmene nad ovom politikom privatnosti, obavestićemo vas tako
                  što ćemo staviti vidljivu napomenu na veb lokaciji.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>Kontaktirajte nas</h6>
                <p className="terms-para">
                  Ako imate bilo kakva pitanja u vezi ove politike privatnosti,
                  kontaktirajte nas. Telefon: 00381113216815 E-pošta:
                </p>
              </Col>
            </Row>
          </Container>
        ) : config.subDomain === "uk" ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>PRIVACY</h6>
                <p className="terms-para">
                  This Privacy Policy outlines how Mobimilia. and its affiliated
                  enterprises (collectively referred to as “we”, “us”, or “our”)
                  collect, use, and protect your information when you access or
                  use our products and services (the “Services”). This Privacy
                  Policy is incorporated into and governed by the same Terms and
                  Conditions that apply to the Services.
                </p>
                <p>
                  By using our Services, you agree to the collection and use of
                  your information in accordance with this Privacy Policy. If
                  you do not agree, please refrain from using the Services.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>1. Information We Collect</h6>
                <p className="terms-para">
                  We collect information in the following ways:
                </p>
                <p className="terms-para">a. Information You Provide</p>
                <p>
                  When you interact with our Services—such as subscribing,
                  participating in quizzes or games, or completing forms—we may
                  collect personal details like your phone number or information
                  necessary to process your subscription. In some cases, this
                  data is collected by your mobile operator and handled in
                  accordance with their privacy policy.
                </p>
                <p className="terms-para">
                  b. Automatically Collected Technical Data
                </p>
                <p className="terms-para">
                  We automatically collect technical information when you access
                  our Services, such as:
                </p>
                <ul>
                  <li>Device type and operating system</li>
                  <li>IP address</li>
                  <li>Browser type</li>
                  <li>Session data (e.g., login/log-out times)</li>
                  <li>Usage patterns and interactions with our Services</li>
                </ul>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  2. How We Use Your Information
                </h6>
                <p className="terms-para">We may use your information to:</p>
                <ul>
                  <li>Provide the Services you request or subscribe to</li>
                  <li>Process billing through your mobile operator</li>
                  <li>
                    Improve the performance and functionality of our Services
                  </li>
                  <li>
                    Monitor usage, detect fraud, and ensure Service security
                  </li>
                </ul>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  3. How Long We Keep Your Data
                </h6>
                <p className="terms-para">
                  We retain your information only as long as necessary:
                </p>
                <ul>
                  <li>To provide you with the Services</li>
                  <li>To comply with legal or regulatory requirements</li>
                  <li>To resolve disputes and enforce agreements</li>
                </ul>
                <p className="terms-para">
                  Once your data is no longer needed, we will either delete it
                  securely or anonymize it so it cannot be used to identify you.
                </p>
              </Col>

              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  4. Data Protection and International Transfers
                </h6>
                <p className="terms-para">
                  We take appropriate technical and organizational measures to
                  protect your information from unauthorized access, alteration,
                  or destruction. However, no method of data transmission or
                  storage is 100% secure.
                </p>
                <p className="terms-para">
                  Because our operations and infrastructure are global, your
                  information may be stored or processed in countries outside of
                  your own, including Singapore, the USA, or others where we
                  operate. In all such cases, we strive to apply equivalent
                  levels of data protection and take reasonable steps to ensure
                  your privacy is respected.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>5. Changes to This Policy</h6>
                <p className="terms-para">
                  We may update this Privacy Policy from time to time. Changes
                  will be posted on this page with an updated “Effective” date.
                  Continued use of the Services after changes are posted
                  constitutes your acceptance of the updated Privacy Policy.
                </p>
              </Col>
            </Row>
          </Container>
        ) : window.location.host.indexOf("pt.videoflux.tv") >= 0 ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  PROPRIETÁRIO E CONTROLADOR DE DADOS
                </h6>
                <p className="terms-para">
                  Prizeflix B.V.
                  <br />
                  Van Diemenstraat 356, 1013 CR, Amsterdam, The Netherlands
                </p>

                <h6 className={termTitleClass}>POLÍTICA DE PRIVACIDADE</h6>
                <p className="terms-para">
                  Esta Política de Privacidade explica nossos compromissos e
                  seus direitos em relação às suas informações. Você deve ler
                  atentamente a Política de Privacidade. Se você não concordar
                  com esta Política de Privacidade, por favor, não utilize
                  nossos Sites ou Serviços. A Política de Privacidade está
                  devidamente incorporada e sujeita aos Termos de Serviço e rege
                  os mesmos Serviços e Sites que os mencionados nos Termos de
                  Serviço. Quaisquer termos que utilizamos na Política de
                  Privacidade sem defini-los têm a mesma definição que nos
                  Termos de Serviço.
                </p>

                <h6 className={termTitleClass}>
                  COLETAMOS INFORMAÇÕES DAS SEGUINTES FORMAS:
                </h6>
                <p className="terms-para">
                  Quando você nos dá ou nos dá permissão para obtê-las Se você
                  optar por assinar um Serviço conosco, nós ou a operadora móvel
                  de sua rede coletaremos suas informações relacionadas ao
                  pagamento da assinatura de nossos Serviços. As informações de
                  conta e faturamento coletadas pela operadora de telefonia
                  móvel estão sujeitas às respectivas políticas de privacidade.
                </p>
                <p className="terms-para">
                  Recebemos informações técnicas quando você visita nossos Sites
                  e/ou Serviços. Podemos coletar informações técnicas a seu
                  respeito sempre que você utilizar nossos Serviços. Coletamos
                  dados de registro toda vez que você faz login ou logout de
                  nossos Serviços.
                </p>

                <h6 className={termTitleClass}>
                  COMO USAMOS AS INFORMAÇÕES COLETADAS
                </h6>
                <p className="terms-para">
                  Podemos utilizar suas informações para os seguintes
                  propósitos:
                </p>
                <ul>
                  <li>Prestar o(s) serviço(s) solicitado(s);</li>
                  <li>
                    Cobrar e cobrar pelo(s) Serviço(s) que lhe for(em)
                    fornecido(s) a você;
                  </li>
                </ul>

                <h6 className={termTitleClass}>
                  QUANTO TEMPO GUARDAMOS SUAS INFORMAÇÕES
                </h6>
                <p className="terms-para">
                  Conservaremos suas informações pelo tempo necessário para
                  fornecer nossos serviços a você. Conservaremos suas
                  informações conforme necessário para cumprir com nossas
                  obrigações legais, resolver disputas e fazer cumprir nossos
                  acordos. Quando não precisarmos mais usar suas informações e
                  não houver mais necessidade de mantê-las para cumprir com
                  nossas obrigações legais ou regulatórias, as removeremos de
                  nossos sistemas ou as despersonalizaremos para que não
                  possamos mais identificá-lo.
                </p>

                <h6 className={termTitleClass}>
                  COMO PROTEGEMOS SUAS INFORMAÇÕES TAMBÉM FORA DA UE
                </h6>
                <p className="terms-para">
                  Estamos preocupados em proteger sua privacidade e dados, mas
                  não podemos assegurar ou garantir a segurança de qualquer
                  informação que você nos transmita ou garantir que suas
                  informações não possam ser acessadas, divulgadas, alteradas ou
                  destruídas por violação de qualquer uma de nossas salvaguardas
                  físicas, técnicas ou gerenciais padrão da indústria. Adotamos
                  práticas apropriadas de coleta, armazenamento e processamento
                  de dados e medidas de segurança para proteger contra acesso
                  não autorizado ou acidental, alteração, divulgação ou
                  destruição de suas informações, informações sobre transações e
                  dados armazenados em nossos Serviços.
                </p>
                <p className="terms-para">
                  Entretanto, nenhum método de transmissão pela Internet ou
                  método de armazenamento eletrônico é 100% seguro. Portanto,
                  não podemos garantir sua segurança absoluta. Continuaremos a
                  melhorar nossos procedimentos de segurança à medida que novas
                  tecnologias se tornem disponíveis.
                </p>
                <p className="terms-para">
                  Como operamos internacionalmente, suas informações, incluindo
                  informações pessoais, poderão ser transferidas e
                  disponibilizadas nos.EUA/Singapura e/ou em qualquer outro país
                  que não seja seu país de residência. Também nesses países,
                  tomamos todos os cuidados razoáveis para proteger suas
                  informações pessoais.
                </p>

                <h6 className={termTitleClass}>
                  ACEITAÇÃO DA POLÍTICA DE PRIVACIDADE
                </h6>
                <p className="terms-para">
                  Ao utilizar qualquer de nossos Serviços, você consente com
                  nossa coleta e uso de suas informações de acordo com esta
                  Política de Privacidade. Reservamo-nos o direito de modificar
                  esta Política de Privacidade a qualquer momento, colocando as
                  alterações nesta página. Favor verificar a data de revisão no
                  final desta página para determinar se a política foi
                  modificada desde a última vez que você a revisou. Seu uso
                  continuado de qualquer parte de nosso Site ou Serviços após a
                  publicação da Política de Privacidade atualizada constituirá
                  sua aceitação das mudanças.
                </p>

                <h6 className={termTitleClass}>
                  ALTERAÇÕES A ESTA POLÍTICA DE PRIVACIDADE
                </h6>
                <p className="terms-para">
                  Podemos fazer mudanças em nossa Política de Privacidade de
                  tempos em tempos. Se decidirmos mudar nossa Política de
                  Privacidade, publicaremos essas mudanças nesta página para que
                  você possa sempre acessar a mais recente Política de
                  Privacidade.
                </p>

                <h6 className={termTitleClass}>CONTATANDO-NOS</h6>
                <p className="terms-para">
                  Se você tiver alguma dúvida sobre esta Política de
                  Privacidade, as práticas dos Sites, ou suas relações com os
                  Sites, por favor, entre em contato conosco enviando um e-mail
                  para pt-videoflux@cchelp.co.
                </p>
              </Col>
            </Row>
          </Container>
        ) : (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <p className="terms-para">
                  <FormattedMessage
                    id="privacyPolicyBody"
                    defaultMessage="This Privacy Policy explains our commitments and your rights concerning your information.
                             You should read the Privacy Policy carefully. If you do not agree with this Privacy Policy, 
                             please do not use our Sites or Services. The Privacy Policy is duly incorporated and subject
                              to the Terms of Service and governs the same Services and Sites as the ones mentioned in the 
                              Terms of Service. Any terms we use in the Privacy Policy without defining them have the same 
                              definition as in the Terms of Service."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyCollectInfoTitle"
                    defaultMessage="WE COLLECT INFORMATION THE FOLLOWING WAYS"
                  />
                  :
                </h6>
                <p className="terms-para">
                  1.{" "}
                  <FormattedMessage
                    id="privacyPolicyCollectInfo_one"
                    defaultMessage="When you give it to us or give us permission to obtain it If you choose to subscribe to a Service
                             from us, we or the mobile operator of your network will collect your information related to the
                              payment for the subscription of our Services. Account and billing information collected by the
                               mobile operator are subject to their respective privacy policies. "
                  />
                </p>
                <p className="terms-para">
                  2.{" "}
                  <FormattedMessage
                    id="privacyPolicyCollectInfo_two"
                    defaultMessage="We get technical information when you visit our Sites and/or Services We may collect technical information
                                about you whenever you use our Services. We collect log data every time you log in or log out of our Services."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyHowWeUseTitle"
                    defaultMessage="HOW WE USE COLLECTED INFORMATION"
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="privacyPolicyHowWeUse"
                    defaultMessage="We may use your information for the following purposes: 

                            Provide the Service(s) you request

                            Bill and collect for the Service(s) provided to you"
                  />{" "}
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyHowLongWeKeepTitle"
                    defaultMessage="HOW LONG WE KEEP YOUR INFORMATION"
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="privacyPolicyHowLongWeKeep"
                    defaultMessage="We will retain your information for as long as needed to provide our Services to you. We will retain your information as necessary to comply with our legal obligations, resolve disputes and enforce our agreements.
                            When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we will either remove it from our systems or depersonalize it so that we can no longer identify you."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyHowWeProtectTitle"
                    defaultMessage="HOW WE PROTECT YOUR INFORMATION ALSO OUTSIDE THE EU"
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="privacyPolicyHowWeProtect"
                    defaultMessage="We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services.

                             However, no method of transmission over the internet or method of electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security. We will continue to enhance our security procedures as new technology becomes available.  
                             
                             Because we operate internationally, your information, including personal information, may be transferred to and made available in the USA/Singapore and/or any other country than your country of residence. Also in these countries, we take all reasonable care to protect your personal information.   
                            "
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyUsingServicesTitle"
                    defaultMessage="ACCEPTANCE OF PRIVACY POLICY"
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="privacyPolicyUsingServices"
                    defaultMessage="By using any of our Services, you consent to our collection and use of your information in accordance with this Privacy Policy. We reserve the right to modify this Privacy Policy at any time by posting the changes on this page. Please check the revision date at the bottom of this page to determine if the policy has been modified since you last reviewed it. Your continued use of any portion of our Site or Services following the posting of the updated Privacy Policy will constitute your acceptance of the changes.    "
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyChangesTitle"
                    defaultMessage="CHANGES TO THIS PRIVACY POLICY"
                  />
                </h6>
                <p className="terms-para">
                  <FormattedMessage
                    id="privacyPolicyChanges"
                    defaultMessage="We may make changes in our Privacy Policy from time to time. If we decide to change our Privacy Policy, we will post those changes on this page so that you can always access the latest Privacy Policy."
                  />
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>
                  <FormattedMessage
                    id="privacyPolicyConnectingUsTitle"
                    defaultMessage="CONTACTING US"
                  />
                </h6>
                <p className="terms-para">
                  {config.subDomain === "my" ? (
                    "You may contact our Customer Care Team at 03-2775 2064 /+6018-780 0852 or through email at cs@sam-media.com. Our dedicated Customer Care Team will be more than happy to answer your questions or solve any issues. Please note that the operating hours for our Customer Care Team is only from Monday to Friday, 9.30AM to 6.00PM."
                  ) : (
                    <FormattedMessage
                      id="privacyPolicyConnectingUs"
                      defaultMessage="If you have a question about this Privacy Policy, the practices of the Sites, or your dealings with the Sites, please contact us by sending an e-mail to support@content-clubs.com."
                    />
                  )}
                </p>
              </Col>
            </Row>
          </Container>
        )}
      </section>
    );
  }

  __getTermsConditions() {
    let termTitleClass = "terms-title";
    return (
      <section className="terms-conditions">
        {config.subDomain === "rs" ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">USLOVI</h6>
                <h6 className="terms-title">1. Opseg uslova</h6>
                <p className="terms-para">
                  Sledeći opšti uslovi i odredbe su deo svakog ugovora između
                  kompanije Sam Media B.V. (dalje u ovom tekstu kao „davalac
                  usluge“) i korisnika davaočevih usluga. Ovim opštim uslovima
                  se obavezuju još i pravni naslednici davaoca usluga i
                  korisnika.
                </p>
                <p className="terms-para">
                  Davalac usluga nudi korisniku mogućnost pristupa sadržaja
                  ponuđenog na veb stranici, i korišćenja istog, putem mobilnog
                  uređaja (mobilnog telefona) korisnika, uz naknadu. Predmet
                  ovih opštih uslova i odredaba su svi propisi koje će ugovorne
                  strane doneti u tom pogledu.
                </p>
                <p className="terms-para">
                  Ovi opšti uslovi i odredbe važe isključivo za korisnike iz
                  Srbije.
                </p>
                <p className="terms-para">
                  Davalac usluga pruža svoje usluge isključivo na osnovu ovih
                  opštih uslova i odredaba.
                </p>
                <p className="terms-para">
                  Važenje ovih opštih uslova i odredaba proširuje se na sve
                  usluge koje davalac usluga nudi na veb stranici. Korišćenjem
                  usluga davaoca, korisnik prihvata ove opšte uslove i odredbe
                  kao obavezujuće za sebe.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">2. Zaključenje ugovora</h6>
                <p className="terms-para">
                  Predstavljanje usluga davaoca na veb stranici ne čini
                  obavezujućom ponudu davaoca, već samo poziv korisniku da
                  podnese ponudu.
                </p>
                <p className="terms-para">
                  Ugovor se zaključuje tako što korisnik aktivira dugme za
                  potvrdu ili reprodukciju prikazano na mobilnom uređaju
                  korisnika nakon pristupa usluzi davaoca i nakon što davalac
                  usluga naknadno postavi uslove i odredbe usluge.
                </p>
                <p className="terms-para">
                  Odmah nakon postavljanja opcije korišćenja, korisnik može da
                  pristupi svim uslugama koje se nude na sajtu, i da ih koristi,
                  preko svog mobilnog uređaja.
                </p>
                <p className="terms-para">
                  Važeće su one cene koje su saopštene korisniku. One uključuju
                  obavezni PDV, primenjuju se za navedeni period i odnose se
                  samo na davanje mogućnosti korišćenja davaočevih usluga. U
                  cene nisu uključene naknade za povezivanje koje nastaju
                  prilikom pristupa davaočevim uslugama, a koje korisniku
                  naplaćuje njegov davalac usluga mobilne telefonije.
                </p>
                <p className="terms-para">
                  Naknada koju korisnik plaća za korišćenje davaočevih usluga
                  dospeva odmah po zaključivanju ugovora i bez odbitaka. Ovu
                  naknadu u ime davaoca usluge naplaćuje davalac usluga mobilne
                  telefonije korisnika kao deo redovnog obračuna.
                </p>
                <p className="terms-para">
                  Korisnik dobija jednostavno, neprenosivo, lokalno neograničeno
                  pravo korišćenja tokom trajanja ovog ugovora za usluge koje
                  pruža davalac.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">3. Uslovi plaćanja</h6>
                <p className="terms-para">
                  Važeće su one cene koje su saopštene korisniku. One uključuju
                  obavezni PDV, primenjuju se za navedeni period i odnose se
                  samo na davanje mogućnosti korišćenja davaočevih usluga. U
                  cene nisu uključene naknade za povezivanje koje nastaju
                  prilikom pristupa davaočevim uslugama, a koje korisniku
                  naplaćuje njegov davalac usluga mobilne telefonije.
                </p>
                <p className="terms-para">
                  Naknada koju korisnik plaća za korišćenje davaočevih usluga
                  dospeva odmah po zaključivanju ugovora i bez odbitaka. Ovu
                  naknadu u ime davaoca usluge naplaćuje davalac usluga mobilne
                  telefonije korisnika kao deo redovnog obračuna.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">4. Prava na korišćenje</h6>
                <p className="terms-para">
                  Korisnik dobija jednostavno, neprenosivo, lokalno neograničeno
                  pravo korišćenja tokom trajanja ovog ugovora za usluge koje
                  pruža davalac.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">5. Pristupačnost</h6>
                <p className="terms-para">
                  Davalac usluga garantuje dostupnost usluga koje pruža u obimu
                  99,5% u proseku godišnje. Ukoliko takva dostupnost nije
                  moguća, korisnik može kod davaoca usluge da ostvari pravo na
                  sniženje cene. Iznos tog sniženja je ograničen na iznos koji
                  je korisnik morao da plati po osnovu ovog ugovora u periodu u
                  kojem nije postojala garantovana dostupnost.
                </p>
                <p className="terms-para">
                  Davalac osmišljava svoju ponudu u skladu sa tehničkim
                  standardima dostupnim na tržištu i na taj način pokušava da
                  obezbedi da korisnik može da iskoristi prednosti usluga
                  davaoca. Međutim, davalac ne može garantovati da se uslugama
                  koje nudi može pristupiti preko svih mobilnih uređaja na
                  tržištu.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  6. Ograničenje odgovornosti i obeštećenje
                </h6>
                <p className="terms-para">
                  Davalac usluga je odgovoran samo za one štete koje isključuju
                  štete nastale kao posledice povrede života, tela i zdravlja
                  ako su zasnovane na namernom ili krajnje nemarnom ponašanju
                  davaoca usluga, njegovih zaposlenih ili njegovih pomoćnih
                  zastupnika. Ovo se odnosi i na štete nastale zbog kršenja
                  obaveza tokom pregovora o ugovoru i izvođenja neovlašćenih
                  radnji.
                </p>
                <p className="terms-para">Telefon: 00381113216815</p>
                <p className="terms-para">
                  Email: <strong>sammedia.rs@silverlines.info</strong>
                </p>
              </Col>
            </Row>
          </Container>
        ) : config.subDomain == "za.fun-box" ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Introduction</h6>
                <p className="terms-para">
                  FunBox is a subscription service charged at R7/day for Vodacom
                  customers and R7/day for MTN, Cell C, and Telkom customers.
                  Subscribers receive unlimited access to premium mobile
                  content. By using the service, you confirm that you are 18
                  years or older and have the bill payer's permission.
                  Compatible handsets are required, and additional network fees
                  may apply.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Subscription and Billing</h6>
                <p className="terms-para">
                  Upon subscription, you will receive a Welcome Message. The
                  subscription fee will be charged directly to your mobile
                  account or deducted from your prepaid balance, depending on
                  your mobile network operator. Charges will recur daily until
                  you unsubscribe. To unsubscribe, follow the instructions in
                  the content portal or dial *135**997# (Vodacom), *123# (MTN),
                  *133# (Cell C), or the relevant Telkom shortcode.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Access and Use</h6>
                <p className="terms-para">
                  The service must not be used to engage in illegal activities,
                  including but not limited to the creation, storage, or
                  distribution of illegal content or infringement of copyright
                  or intellectual property rights. The service provider reserves
                  the right to terminate your subscription if these terms are
                  breached. The service must only be used with the permission of
                  the bill-payer. Users of the service may not:
                  <ul>
                    <li>
                      Knowingly create, store, or disseminate any illegal
                      content,
                    </li>
                    <li>Knowingly infringe copyright,</li>
                    <li>
                      Knowingly infringe any intellectual property rights, or
                    </li>
                    <li>Send spam or promote the sending of spam.</li>
                  </ul>
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Service Availability and Restrictions
                </h6>
                <p className="terms-para">
                  The service is available on compatible devices only. The
                  service provider does not guarantee uninterrupted access or
                  error-free operation. Service may be suspended or restricted
                  due to technical, operational, or legal reasons. The service
                  provider reserves the right to modify or discontinue the
                  service at any time without prior notice.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Content and Intellectual Property
                </h6>
                <p className="terms-para">
                  All content provided through FunBox is protected by copyright
                  and other intellectual property laws. You are granted a
                  non-transferable, non-exclusive license to use the content for
                  personal, non-commercial use only. Any unauthorized use,
                  distribution, or reproduction of the content is strictly
                  prohibited and may result in the termination of your
                  subscription and/or legal action.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Termination</h6>
                <p className="terms-para">
                  The service provider reserves the right to suspend or
                  terminate your subscription without notice if it determines,
                  at its sole discretion, that you have violated these terms.
                  Upon termination, your access to the service will cease
                  immediately. You may also terminate your subscription at any
                  time by following the unsubscribe instructions provided in the
                  content portal or via the designated USSD strings.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Refunds</h6>
                <p className="terms-para">
                  Refunds may be provided at the sole discretion of the service
                  provider and in compliance with applicable laws. If you are
                  dissatisfied with the service or if the service was not as
                  described, you must contact customer support within seven days
                  of subscription for a possible refund.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Privacy and Data Protection</h6>
                <p className="terms-para">
                  By using FunBox, you agree to the collection, use, and sharing
                  of your personal data in accordance with our Privacy Policy.
                  We are committed to protecting your privacy and handling your
                  data transparently.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Limitation of Liability</h6>
                <p className="terms-para">
                  The service is provided on an "as is" and "as available"
                  basis. The service provider makes no warranties or
                  representations, express or implied, regarding the service's
                  operation or the information, content, or materials provided.
                  The service provider shall not be liable for any direct,
                  indirect, incidental, or consequential damages arising from
                  your use of the service.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Governing Law and Dispute Resolution
                </h6>
                <p className="terms-para">
                  These terms shall be governed by the laws of South Africa. Any
                  disputes arising from or related to these terms will be
                  subject to the exclusive jurisdiction of the South African
                  courts.
                </p>
                <p className="terms-para">
                  Sam Media is a member of WASPA and is bound by the WASPA Code
                  of Conduct. Customers have the right to approach WASPA to
                  lodge a complaint in accordance with the WASPA complaints
                  procedure. Sam Media may be required to share information
                  relating to a service or a customer with WASPA for the purpose
                  of resolving a complaint. WASPA website: www.waspa.org.za.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Customer Support</h6>
                <p className="terms-para">
                  For assistance, contact our customer service team at 011 507
                  4779 or email info@smartcalltech.co.za.
                </p>
              </Col>
            </Row>
          </Container>
        ) : config.subDomain === "uk" ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">TERMS AND CONDITIONS</h6>
                <p className="terms-para">
                  These General Terms and Conditions (the “Terms”) govern the
                  use of any products and services offered temporarily by
                  Mobimilia., or any of its affiliated enterprises (hereinafter
                  referred to as “the Provider”) across mobile or internet
                  platforms, including but not limited to WAP, SMS, mobile data
                  (e.g. 3G, 4G, 5G), WiFi, web, and other connected
                  technologies.
                </p>
                <p className="terms-para">
                  By accessing or using the Provider’s services (the
                  “Services”), you acknowledge that you have read, understood,
                  and agree to be bound by these Terms, including any
                  supplementary guidelines, promotional conditions, or
                  provisions published and made applicable at the time of use.
                  These Terms may be updated or amended at any time without
                  prior notice.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">1. Description of Services</h6>
                <p className="terms-para">
                  The Provider offers a range of mobile and internet-based
                  services including, but not limited to, online games, content
                  downloads, quizzes, messaging services, streaming content,
                  interactive tools, immersive learning materials, and access to
                  online resources.
                </p>
                <p className="terms-para">
                  These Services may be accessed through various devices
                  including mobile phones, tablets, smart devices, or personal
                  computers, and may include future updates, new
                  functionalities, or platform enhancements introduced by the
                  Provider.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">2. Availability of Service</h6>
                <p className="terms-para">
                  The Services are provided “as is” and “as available”, based on
                  their current developmental stage. The Provider does not
                  guarantee uninterrupted, error-free, or secure service
                  availability.
                </p>
                <p className="terms-para">
                  The Provider is not liable for any failures in data storage,
                  delayed messages, or losses resulting from the use of the
                  Services. Users are responsible for ensuring they have the
                  appropriate devices, software, and network access to use the
                  Services, and for any associated costs.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">3. Payment and Billing</h6>
                <p className="terms-para">
                  Some Services may be offered free of charge, while others may
                  incur fees. When applicable, charges for Services will be
                  billed via your mobile operator’s billing system or as
                  otherwise communicated by the Provider.
                </p>
                <p className="terms-para">
                  You agree to pay all applicable fees, including any taxes
                  (e.g., VAT or similar levies), which may be imposed now or in
                  the future by relevant local or international authorities. The
                  Provider reserves the right to revise pricing or payment terms
                  at any time, with such updates published on the relevant
                  service platform or product page.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  4. Registration and User Responsibility
                </h6>
                <p className="terms-para">
                  To access certain Services, you may be required to register
                  and provide accurate, up-to-date personal information
                  (“Registered Information”).
                </p>
                <p className="terms-para">You agree to:</p>
                <ul>
                  <li>
                    Ensure that the Registered Information is true, accurate,
                    and complete at all times.
                  </li>
                  <li>
                    Maintain the confidentiality of any passwords or accounts
                    issued to you.
                  </li>
                  <li>
                    Notify the Provider immediately if you suspect unauthorized
                    use of your account.
                  </li>
                </ul>
                <p>
                  The Provider reserves the right to suspend or terminate access
                  if the Registered Information is suspected to be false or
                  misleading. You are solely responsible for any activity under
                  your account, including consequences arising from your failure
                  to safeguard your login credentials.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  5. Ownership and Intellectual Property
                </h6>
                <p className="terms-para">
                  All content, software, logos, trademarks, and materials made
                  available through the Services are the exclusive property of
                  the Provider or its licensors. Users are granted a
                  non-exclusive, non-transferable right to access and use the
                  Services solely for personal and non-commercial purposes.
                </p>
                <p className="terms-para">
                  You may not reproduce, modify, distribute, publicly display,
                  or create derivative works of the Service content without
                  explicit written permission from the Provider.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">6. Amendments and Validity</h6>
                <p className="terms-para">
                  These Terms may be updated at any time, and such changes will
                  take effect upon publication. It is your responsibility to
                  review the latest version regularly.
                </p>
              </Col>
            </Row>
          </Container>
        ) : window.location.host.indexOf("pt.videoflux.tv") >= 0 ? (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className={termTitleClass}>TERMOS E CONDIÇÕES</h6>

                <h6 className={termTitleClass}>Condições gerais</h6>
                <p className="terms-para">
                  Bem-vindo(a) ao Prizeflix BV, no endereço
                  http://pt.videoflux.tv (o Website).
                </p>
                <p className="terms-para">
                  Por favor leia cuidadosamente estes Termos e Condições Gerais
                  (‘os Termos’). Este documento no idioma local é uma tradução
                  do documento original na língua inglesa, e é fornecido ao
                  Cliente como cortesia. Caso exista alguma discrepância entre o
                  documento traduzido e o documento original e em caso de
                  quaisquer disputas, prevalecerá este último. Por favor tenha
                  em atenção que os Serviços abrangidos por este acordo não
                  poderão ser cancelados por si, a menos que do modo delineado
                  nestes Termos, uma vez a provisão desses Serviços tenha
                  iniciado. Se não concordar com estes Termos, não deverá
                  continuar o registo ou quaisquer tentativas de aceder aos
                  Serviços do website, que estão abrangidos por estes Termos. De
                  outro modo, estará a concordar com o uso dos Serviços, de
                  acordo com os Termos estabelecidos. De tempos a tempos,
                  poderemos necessitar de variar estes Termos e quaisquer
                  mudanças serão efectuadas em conformidade com estes Termos.
                  Por favor visite regularmente este website, pois será aqui que
                  notificaremos os clientes sobre quaisquer mudanças.
                </p>

                <h6 className={termTitleClass}>
                  1. DESCRIÇÃO E TIPOS DE SERVIÇOS
                </h6>
                <p className="terms-para">
                  A Prizeflix BV (‘Empresa’, ‘Nós’) desenvolveu uma variedade de
                  conteúdos móveis de entretenimento para download, quer online
                  ou wireless, tais como, mas não limitados a toques, jogos,
                  wallpapers e Serviços de SMS (colectivamente, os ‘Serviços’),
                  para certos aparelhos móveis compatíveis (adiante designados
                  por ‘os Serviços’). Estes Serviços são-lhe oferecidos por:
                  Prizeflix BV, Van Diemenstraat 356 - 1013CR Amsterdam.
                </p>
                <p className="terms-para">
                  Os Serviços são disponibilizados ao público, de acordo com
                  estes Termos. Os Serviços incluirão acesso a informação,
                  dados, texto, software, música, som, fotografias, gráficos,
                  vídeos, mensagens ou outros materiais. Os serviços não se
                  destinam a fornecer impostos, contabilidade ou aconselhamento
                  jurídico, aconselhamento sobre a adequação ou lucro de
                  qualquer título ou de investimento, aconselhamentos de saúde
                  ou médicos, ou qualquer outro aconselhamento de carácter
                  pessoal ou privado. Os Serviços poderão também incluir o
                  acesso a conteúdos e serviços de terceiros independentes. Após
                  o registo e pagamento correctos, o Cliente terá permissão para
                  transferir ou, de outra forma, utilizar os Serviços através de
                  telemóveis e outros aparelhos compatíveis. A Empresa oferece
                  os seus Serviços (a) através de um modelo contínuo de
                  subscrição (b) como um modelo de crédito, no qual é oferecido
                  um pacote de créditos, correspondente a um número definido de
                  downloads individuais numa base renovável (periódica) de
                  subscrição e (c), através de um (único) modelo de compra. Nem
                  todos os modelos poderão estar disponíveis no seu país.
                  Informações mais específicas relativamente aos Serviços
                  oferecidos no seu país, poderão ser encontradas no Website.
                  Salvo indicação expressa em contrário, nenhuma informação
                  apresentada nos Serviços, ou em ligação aos Serviços será
                  considerada como proposta vinculativa por parte da Empresa,
                  mas sim um convite para que o Cliente possa encomendar
                  Serviços. A Empresa terá o direito de prestar os Serviços como
                  considerar melhor, mas tentará garantir que os Serviços não
                  são de menor qualidade do que na data em que estes Termos
                  foram firmados. Sujeito ao direito dos clientes, de serem
                  reembolsados de taxas de acordo com estes termos, a Empresa
                  reserva o direito de modificar ou descontinuar, temporária ou
                  permanentemente, os serviços prestados aos clientes. Se o
                  Serviço for permanentemente descontinuado por nós,
                  notificaremos os clientes deste facto.
                </p>

                <h6 className={termTitleClass}>2. REGISTO E ACESSO</h6>
                <p className="terms-para">
                  É necessário ter pelo menos dezoito anos de idade, para
                  subscrever a qualquer um dos Serviços. Se você não é a pessoa
                  responsável pelo pagamento do telemóvel ou da conta da
                  Internet, ou tiver idade inferior a dezoito anos de idade, por
                  favor obtenha a permissão de quem paga a conta, dos seus pais,
                  tutor e/ou empregadores, antes de subscrever e/ ou participar
                  nos Serviços. Ao subscrever e/ou participar nos Serviços, você
                  (1) reconhece e confirma que, onde requerido, obteve a
                  permissão necessária, consentimento ou aprovação de quem paga
                  as contas, dos pais, tutor ou empregador e (2), aceita que lhe
                  foi dada a oportunidade de ler e aceitar os Termos antes de
                  utilizar os Serviços. Se não concordar, não deverá utilizar os
                  Serviços. Ao inscrever-se para e / ou utilizar o Serviço,
                  reconhece e confirma a aceitação destes Termos e que cumpre
                  com os termos que se aplicarem à sua situação, conforme
                  especificado acima. O Cliente concorda que cada pessoa que
                  solicitar tais Serviços é o seu agente, com plena autoridade
                  para agir em seu nome, relativamente a tais Serviços. A menos
                  que expressamente indicado em contrário, qualquer
                  característica nova ou adicional que aumente ou aprimore os
                  Serviços actuais, incluindo o lançamento de novos Serviços,
                  estará sujeita aos Termos.
                </p>

                <h6 className={termTitleClass}>
                  3. Obrigação de registo; Dados Pessoais
                </h6>
                <p className="terms-para">
                  A pedido deste, a empresa poderá registar o Cliente como
                  utilizador e dar-lhe acesso aos Serviços, atribuindo-lhe um
                  nome de utilizador e uma password. O Cliente é o único
                  responsável por manter a confidencialidade de qualquer
                  password e conta. A Empresa poderá ter de alterar os nomes
                  atribuídos a certos aspectos dos seus Serviços, e reserva-se o
                  direito de fazê-lo (o Cliente será informado caso seja
                  necessário). Com vista a garantir a utilização segura dos
                  Serviços, bem como o pagamento das taxas aplicáveis, o Cliente
                  garantirá que em todas as alturas as informações pessoais
                  (doravante referidas como os ‘Dados Pessoais’) fornecidas na
                  ficha de inscrição, estão correctas e completas. Se a Empresa,
                  a seu exclusivo critério, considerar que as Informações
                  Pessoais não estão correctas ou completas, tem o direito de
                  suspender ou encerrar a sua conta e de recusar o uso actual e
                  futuro dos Serviços, ou de qualquer um dos seus componentes. O
                  Cliente é responsável por manter o sigilo de todas as
                  passwords e / ou contas emitidas para si pela Empresa, e é
                  totalmente responsável por todas as acções realizadas, que
                  envolvam a utilização da sua password, ou conta. O Cliente
                  compromete-se a contactar a Empresa, caso observe ou suspeite
                  do uso não autorizado da sua password ou conta, ou que a
                  segurança ou protecção dos Dados Pessoais já não está
                  garantida, por qualquer outro motivo. A Empresa não pode e não
                  será responsabilizada por quaisquer perdas ou danos
                  decorrentes do não cumprimento desta Secção. A Empresa poderá
                  fornecer-lhe o acesso a alguns Serviços, tais como inscrições
                  para os serviços via telemóvel, sem que o Cliente se registe
                  como utilizador. Em cada caso, a sua identificação é baseada
                  em meios de identificação considerados adequados, tais como o
                  número do seu telemóvel. O Cliente concorda que estas
                  informações podem ser recolhidas e divulgadas à Empresa, e
                  utilizadas de acordo com a Secção “Privacidade e Processamento
                  de Dados” dos presentes Termos.
                </p>

                <h6 className={termTitleClass}>
                  4. Acesso ao Modelo Contínuo de Subscrição
                </h6>
                <p className="terms-para">
                  A subscrição contínua terá início quando a Empresa, mediante a
                  sua solicitação, lhe fornecer acesso aos Serviços. O acesso
                  aos Serviços pode ser fornecido através do envio ao Cliente de
                  Serviços informativos ou de entretenimento (por exemplo,
                  enviar mensagens de texto (tais como anedotas, curiosidades,
                  perguntas de um questionário), ou conteúdos de download (tais
                  como um wallpaper, um toque ou um jogo de telemóvel)),
                  permitindo o acesso aos Serviços (por exemplo, ao seu número
                  de telemóvel) ou permitindo que o Cliente transfira os
                  Serviços (por exemplo, enviando uma link de WAP-Push ou uma
                  link numa mensagem de texto para download, ou utilização de
                  Serviços no site da Empresa). Todos os acordos de subscrição
                  permanecerão em vigor até serem concluídos e / ou cancelados
                  pelo Cliente ou pela Empresa, de acordo com os termos aqui
                  estabelecidos. Os acordos para os Serviços da Empresa e de
                  terceiros independentes, que sejam disponibilizados através
                  dos Serviços, deverão iniciar quando a Empresa ou o terceiro
                  tenha aceite a sua encomenda, ou tiver fornecido ao Cliente os
                  Serviços, em conformidade com o pedido deste. O acordo
                  permanecerá em vigor até ser concluído pelo Cliente ou pela
                  Empresa, de acordo com os termos aqui estabelecidos.
                </p>

                <h6 className={termTitleClass}>
                  5. Acesso ao Modelo de Créditos
                </h6>
                <p className="terms-para">
                  No modelo de créditos oferecido pela Empresa, é fornecido um
                  pacote de créditos para um número definido de downloads
                  individuais, numa base de subscrição renovável. O modelo de
                  créditos é uma subscrição contínua que irá iniciar quando a
                  Empresa fornecer ao Cliente o pacote de créditos. As tarifas e
                  créditos aplicáveis serão comunicados ao Cliente no Website e
                  através dos nossos Serviços. No modelo de créditos, um número
                  definido de créditos será fornecido ao Cliente, o que o
                  autoriza a transferir, receber e/ou aceder ao número definido
                  de downloads disponíveis. O período de subscrição depende do
                  tipo de contrato de subscrição oferecido no país do Cliente. O
                  contrato de subscrição e o período de subscrição serão
                  renovados a cada período conforme aplicável, e uma nova tarifa
                  de subscrição será devida pelo novo período de subscrição. O
                  contrato de subscrição permanecerá em vigor até ser concluído
                  e / ou cancelado pelo Cliente ou pela Empresa, de acordo com
                  os termos aqui estabelecidos. Após estabelecer o acordo de
                  subscrição e mediante o pagamento da tarifa de subscrição
                  aplicável pelo período de subscrição relevante, a Empresa irá
                  transferir o pacote de créditos de download para a conta do
                  Cliente. A taxa periódica de subscrição será devida, a cada
                  período que o seu acordo de subscrição seja válido,
                  independentemente de o Cliente ter ou não, transferido
                  qualquer Serviço, durante um qualquer período da subscrição; a
                  importância da taxa fixa periódica será apenas a provisão
                  periódica do direito de transferir, receber e / ou aceder a
                  Serviços transferíveis. O número de créditos para downloads
                  será reduzido de acordo com os Serviços transferidos. Os
                  créditos não poderão ser trocados por dinheiro, são
                  intransferíveis e dependem do tipo de acordo de subscrição que
                  foi requerido. Se o Cliente não utilizar / trocar todos os
                  seus créditos dentro do período de subscrição, os créditos não
                  utilizados (a) serão transferidos para o período de subscrição
                  seguinte, permanecendo na sua conta até serem utilizados /
                  trocados, ou até à expiração ou rescisão do seu acordo de
                  subscrição ou, se mais cedo, (b) serão expirados num prazo de
                  90 dias após a sua atribuição. Os créditos só poderão ser
                  utilizados para transferir os Serviços oferecidos pela
                  Empresa.
                </p>

                <h6 className={termTitleClass}>
                  6. Acesso ao Modelo Único de Compra
                </h6>
                <p className="terms-para">
                  O modelo único de compra significa que o Cliente poderá
                  seleccionar qualquer um dos serviços únicos que deseja
                  transferir. A possibilidade de transferir, receber e / ou
                  aceder aos Serviços é disponibilizada mediante o pagamento de
                  uma taxa fixa, conforme comunicado no nosso website, ou de
                  outro modo. Não existe subscrição, nem taxas recorrentes
                  envolvidas.
                </p>

                <h6 className={termTitleClass}>7. Custos</h6>
                <p className="terms-para">
                  As taxas dos Serviços estão disponíveis no website da Empresa
                  (por exemplo, em ‘Perguntas Frequentes’). A taxa periódica
                  será cobrada para cada período de subscrição em que o acordo
                  esteja em vigor. O Cliente pagará à Empresa pelos Serviços e
                  utilização dos mesmos, de acordo com as tabelas de preços em
                  vigor no momento da sua encomenda. Salvo indicação em
                  contrário, os custos serão enviados para a conta do seu
                  telemóvel, ou deduzidos do seu saldo. A cobrança de impostos
                  adicionais e de taxas relativas a mensagens de texto de
                  diferentes fornecedores de wireless / WAP / GPRS / UMTS /
                  Largura de banda, poderão ocorrer devido à utilização dos
                  Serviços pelo Cliente. Quando aplicável, os custos poderão
                  também ser pagos usando créditos, com o seu cartão de crédito,
                  por transferência bancária ou através da sua conta de
                  utilizador. Os diferentes métodos de pagamento serão
                  especificados durante o processo de encomenda dos Serviços que
                  o Cliente escolher. A Empresa poderá também cobrar ao Cliente
                  as despesas de terceiros partidos, cujos serviços estão
                  disponíveis através dos Serviços, se tal tiver sido acordado
                  com o dito terceiro partido. Essas despesas serão cobradas de
                  acordo com as taxas desses terceiros partidos. Todas as taxas,
                  incluindo taxas dos actuais contratos de subscrição, estão
                  sujeitas a alteração após notificação da Empresa. A Empresa
                  fornecerá ao Cliente um prazo razoável de notificação dessa
                  alteração. Se o Cliente não aceitar os novos preços (que serão
                  aplicáveis apenas numa base futura), poderá cancelar a sua
                  subscrição e / ou a sua conta, com efeito imediato após a
                  rescisão.
                </p>

                <h6 className={termTitleClass}>
                  8. Responsabilidades do Cliente
                </h6>
                <p className="terms-para">
                  Com vista a utilizar os Serviços, o Cliente deverá possuir uma
                  assinatura de comunicações móveis com um fornecedor de
                  serviços de wireless participante, ou possuir acesso a uma
                  rede de comunicações móveis para a qual a Empresa
                  disponibilize serviços, bem como qualquer fornecedor de
                  serviços de wireless necessários para fazer o download de
                  conteúdos e/ou receber mensagens SMS e pagar todas as taxas
                  (fornecedor de serviços de wireless) de serviços associados a
                  esse acesso. O Cliente deverá possuir uma ligação de Internet
                  funcional no seu telemóvel (por exemplo: WAP, GPRS, UMTS). O
                  seu telemóvel deverá poder receber mensagens de texto, toques,
                  jogos para telemóvel, gráficos de vídeo e / ou coloridos.
                  Adicionalmente, o seu telemóvel terá de possuir uma ligação de
                  Internet que permita transferir toques, jogos para telemóvel,
                  gráficos de vídeo e coloridos, ou outros Serviços
                  transferíveis. A Empresa não efectuará reembolsos, caso o
                  Cliente transfira (ou tente transferir) Serviços para
                  telefones ou fornecedores de serviços sem fios incompatíveis,
                  ou caso o seu telemóvel não possua uma ligação de Internet.
                  Para mais informações, por favor consulte o website do seu
                  fornecedor de serviços wireless, ou o site do fabricante do
                  seu telemóvel. Além disso, o Cliente deverá fornecer todos os
                  equipamentos e software necessários para ligar aos Serviços. O
                  Cliente é responsável por garantir que os equipamentos e / ou
                  software não perturbam nem interferem com as operações da
                  Empresa. A Empresa tem o direito de desligar imediatamente dos
                  Serviços, qualquer equipamento ou software que cause
                  interferências, e de rescindir imediatamente o presente
                  Acordo. Os Serviços destinam-se apenas a uso pessoal e não
                  poderão ser cedidos ou transferidos para qualquer outro número
                  de telemóvel, pessoa ou entidade. O Cliente também não poderá
                  fornecer a qualquer outra pessoa ou entidade, o acesso aos
                  seus Serviços, quer directa ou indirectamente. Qualquer
                  conduta ou actividade que acreditarmos que restrinja ou iniba
                  qualquer outro utilizador de aceder, utilizar ou desfrutar dos
                  Serviços, não será permitida. O Cliente concorda em utilizar
                  os Serviços apenas para fins lícitos.
                </p>

                <h6 className={termTitleClass}>
                  9. Direitos Intelectuais de Propriedade
                </h6>
                <p className="terms-para">
                  Salvo disposição em contrário aqui estabelecida, todos os
                  direitos, títulos e interesses relativos à propriedade
                  intelectual, direitos de propriedade ou outros direitos
                  relacionados com bens incorpóreos que sejam utilizados,
                  desenvolvidos, que compreendam ou incorporem, ou cuja prática
                  tenha qualquer ligação com os Serviços (‘Direitos de
                  Propriedade Intelectual da Empresa’) são propriedade da
                  Empresa ou dos seus licenciadores e o Cliente concorda em não
                  fazer qualquer reivindicação de interesse ou de propriedade de
                  quaisquer Direitos de Propriedade Intelectual da Empresa. Por
                  este meio, a Empresa garante, e o Cliente aceita uma licença
                  pessoal, limitada, não transferível, não exclusiva, revogável
                  e não definível, e permissão para transferir e utilizar os
                  Serviços num designado aparelho móvel compatível, somente para
                  seu próprio uso pessoal, e não comercial. O utilizador
                  reconhece e concorda que não poderá emendar, alugar, arrendar,
                  emprestar, trespassar, pedir emprestado, oferecer, vender,
                  distribuir, criar ou gerar os Serviços e / ou os direitos de
                  Propriedade Intelectual da Empresa, excepto no caso de a
                  Empresa lhe ter concedido permissão explícita por escrito para
                  fazê-lo. O Cliente reconhece que nenhum título aos Direitos de
                  Propriedade Intelectual da Empresa é transferido para si, e
                  que não obterá quaisquer direitos, expressos ou implícitos,
                  nos Serviços, fora os direitos expressamente concedidos nestes
                  Termos. O Cliente reconhece que todas as marcas que aparecem
                  ao longo dos Serviços pertencem à Empresa, ou aos respectivos
                  donos dessas marcas, e que estas estão protegidas por leis
                  nacionais e internacionais de marca e copyright. Qualquer
                  utilização de qualquer uma das marcas que aparecem ao longo
                  dos Serviços, sem o consentimento expresso por escrito da
                  Empresa, ou do proprietário da marca, conforme apropriado, é
                  expressamente proibida. A Prizeflix ' é uma marca da Empresa.
                  Os Serviços poderão ser transferidos apenas uma vez e não
                  poderão ser modificados, vendidos, distribuídos, exibidos,
                  executados, copiados, alterados ou utilizados de qualquer
                  forma, quer no seu todo ou em parte, excepto da forma
                  contemplada por estes Termos. O Cliente garante que utilizará
                  apenas o interface fornecido pela Empresa, para aceder aos
                  Serviços. O Cliente concorda que os detentores dos direitos,
                  que licenciam os seus conteúdos musicais e outros à Empresa,
                  para serem utilizados nos Serviços, são abrangidos pela
                  protecção deste acordo, e que estão, eles próprios,
                  autorizados a aplicar as estipulações deste acordo, que se
                  relacionam directamente com os seus conteúdos. O Cliente sabe
                  que a utilização de peças musicais está sujeita aos termos de
                  utilização, tal como estabelecido abaixo. O Cliente não poderá
                  permitir que terceiros efectuem a cópia, modificação,
                  reprodução, transferência, distribuição ou utilização de
                  qualquer outra forma, de peças musicais, que utilize ou
                  receba, fora dos limites estreitamente permitidos por
                  copyright. O Cliente obriga-se a si próprio a informar de
                  imediato a Empresa, de tais usos não autorizados. Todos os
                  direitos não expressamente concedidos ao Cliente por este
                  acordo, são reservados pela Empresa e / ou os seus
                  licenciadores.
                </p>

                <h6 className={termTitleClass}>
                  10. Acordos para Serviços de Terceiros / Transacções com
                  Anunciantes e / ou Patrocinadores
                </h6>
                <p className="terms-para">
                  Os Serviços poderão também incluir o acesso aos Serviços de
                  terceiros independentes, quer directamente ou via links para
                  os sites explorados por esses terceiros. Onde for
                  razoavelmente possível, a Empresa indicará os Serviços como
                  sendo conteúdo de terceiros. Mesmo que possam ser marcas em
                  parceria com a Empresa e, portanto, incluam marcas da Empresa,
                  os acordos de serviços prestados por terceiros serão
                  concluídos directamente entre o Cliente e o terceiro. Também
                  poderemos utilizar anunciantes e promotores para ajudar a
                  compensar os custos dos nossos Serviços. Como condição para
                  utilizar estes serviços, o Cliente concorda com a exibição de
                  anúncios e outras promoções no nosso site, e com o envio de
                  anúncios e promoções ligados aos nossos Serviços. O Cliente
                  também concorda que não tentará bloquear nem interferir com
                  este tipo de publicidade ou promoções. Algumas jurisdições não
                  permitem que enviemos publicidade em mensagens de texto sem a
                  autorização expressa do Cliente, portanto o precedente poderá
                  não se aplicar a si. Não partilharemos os Dados Pessoais do
                  Cliente com terceiros, sem o consentimento deste. A inclusão
                  de qualquer publicidade ou promoção no nosso website, ou nos
                  nossos Serviços, não constitui qualquer endosso por parte da
                  Empresa, de tal conteúdo, produto, serviço ou empresa.
                  Tentamos assegurar-nos de que todos os anúncios, ou promoções
                  são apropriados para os nossos utilizadores. O Cliente tem o
                  direito de, em qualquer altura, nos pedir para não ser
                  contactado através do marketing directo. A Empresa não deverá
                  ser partido de, ou de qualquer forma, responsável por qualquer
                  transacção relativa a serviços disponibilizados a partir de
                  tais terceiros, ou por qualquer conteúdo ou informação
                  apresentada, em ligação a quaisquer serviços de terceiros.
                </p>

                <h6 className={termTitleClass}>
                  11. Privacidade e Processamento de Dados
                </h6>
                <p className="terms-para">
                  O Cliente reconhece que a Empresa recolhe e processa
                  ‘informações pessoais’ (i.e. informação que poderá ser
                  utilizada para contactar o Cliente, ou fornecida pelo Cliente,
                  tal como nome completo, morada, sexo, idade, opiniões,
                  estimativas, conhecimento, número de telefone ou endereço de
                  e-mail), ‘informação financeira’ (ou seja, números de cartão
                  de crédito, informações bancárias ou senhas), ou ‘informações
                  demográficas e de utilização’ (i.e. informação que o Cliente
                  envia, ou que nós recolhemos, que não é nem informação
                  pessoal, nem informação financeira, mas é necessária ao
                  funcionamento e à facturação adequados dos nossos Serviços,
                  tal como a data relativa ao início e ao final, e à duração da
                  sua utilização dos Serviços), subordinada ao resto deste
                  parágrafo, para operar neste website (referidos em conjunto
                  como ‘Dados Pessoais’) e sujeita aos termos estabelecidos na
                  Declaração de Privacidade, que é parte integral destes Termos
                  e Condições Gerais. A Empresa atribui grande valor à
                  privacidade dos seus utilizadores. Contudo, poderemos
                  transmitir os seus dados pessoais ao seu operador de serviços
                  de wireless, ou fornecedor de serviços de gateway, de modo a
                  garantir a cobrança de taxas. Além disso, podemos transmitir
                  os dados pessoais do Cliente a agências governamentais,
                  incluindo, mas não limitados, aos tribunais e escritórios de
                  advogados, para processos jurídicos e prevenção de crimes. Os
                  Dados Pessoais recolhidos pela Empresa, poderão ser
                  armazenados e processados na Holanda, ou em qualquer outro
                  país onde a Empresa, ou os seus agentes, possuam instalações.
                  Ao utilizar os Serviços, o Cliente estará a concordar com
                  qualquer transferência de Dados Pessoais fora do seu país. Os
                  seus Dados Pessoais serão apagados num prazo de seis meses
                  após o término da sua subscrição. A Empresa poderá armazenar
                  seus Dados Pessoais para além desta data, se tal for exigido
                  por lei ou acordo. A Empresa manterá procedimentos
                  consistentes com as leis aplicáveis a indivíduos, para ter
                  acesso aos seus Dados Pessoais e, quando necessário e mediante
                  solicitação, corrigir ou eliminar os seus Dados Pessoais.
                </p>

                <h6 className={termTitleClass}>
                  12. Aviso Legal de Garantias e Limitação de Responsabilidades
                </h6>
                <p className="terms-para">
                  A Empresa, os seus directores, administradores, funcionários,
                  fornecedores e agentes (os ‘Partidos Provedores’) não assumem
                  qualquer responsabilidade por quaisquer danos resultantes do
                  uso dos Serviços. O Cliente compreende e concorda
                  expressamente, que os Serviços são fornecidos ‘conforme estão’
                  e ‘conforme disponíveis’, sem quaisquer garantias. Os Partidos
                  Provedores renunciam expressamente até à máxima extensão
                  permitida por lei, todas as garantias, quer sejam expressas,
                  implícitas, estatutárias ou não, no que diz respeito aos
                  Serviços, incluindo, sem limitação, as garantias implícitas de
                  título, comercialização, adequação a um propósito particular e
                  não violação de direitos de propriedade. Os Partidos
                  Provedores renunciam quaisquer garantias quanto à segurança,
                  fiabilidade, actualidade e desempenho dos Serviços. Os
                  Partidos Provedores não garantem que os serviços irão
                  satisfazer as necessidades do Cliente, ou que o funcionamento
                  dos Serviços seja ininterrupto e sem erros. Nenhum
                  aconselhamento ou informação, seja ele oral ou escrito, obtido
                  pelo cliente da Empresa, ou através dos nossos Serviços,
                  criará qualquer garantia não expressamente efectuada aqui. O
                  Cliente não poderá confiar em tais informações ou
                  aconselhamentos. O Cliente compreende e concorda com a
                  transferência e / ou utilização dos Serviços, conteúdo,
                  software e websites por sua própria conta e risco, e que será
                  o único responsável por quaisquer danos no seu sistema de
                  computador, telemóvel, ou perda de dados que resultem da
                  utilização dos Serviços. Excepto em jurisdições nas quais tais
                  provisões são restritas, o Cliente concorda que toda a
                  responsabilidade da Empresa para com o Cliente ou qualquer
                  terceiro, e a sua reparação, ou de qualquer terceiro, na lei,
                  equidade ou de outra forma, relativamente aos Serviços
                  fornecidos no âmbito do presente acordo e/ou devido a qualquer
                  violação deste acordo, limita-se apenas ao valor pago por
                  esses Serviços durante a vigência deste acordo. Excepto nas
                  jurisdições onde tais provisões são restritas, os Partidos
                  Provedores não se responsabilizam por quaisquer danos
                  directos, indirectos, incidentais, especiais, exemplares,
                  punitivos, terceiros ou consequenciais (incluindo danos por
                  perda de lucros de negócios, interrupção de negócios, perda de
                  informações comerciais e semelhantes), decorrentes do seu uso,
                  abuso ou incapacidade de utilizar os Serviços, o conteúdo,
                  software e website, mesmo se a Empresa tiver sido avisada da
                  possibilidade de tais danos, na medida em que um país não
                  permite a exclusão ou limitação de responsabilidade, conforme
                  estabelecido aqui, a responsabilidade da Empresa está limitada
                  à extensão permitida por lei nesse país.
                </p>

                <h6 className={termTitleClass}>13. Indemnização</h6>
                <p className="terms-para">
                  O Cliente concorda em indemnizar e manter a Empresa e os seus
                  fundadores, membros, subsidiários, afiliados, provedores de
                  serviços, contratantes, agentes, licenciadores, funcionários,
                  directores, accionistas e empregados, livres de quaisquer
                  perdas, responsabilidades, reclamações, acções jurídicas ou
                  demandas, incluindo taxas jurídicas razoáveis, feitas por
                  quaisquer terceiros devido a, ou resultantes de, ou em ligação
                  (a) ao uso dos Serviços pelo Cliente, e (b) à violação, por
                  parte do Cliente, das representações e garantias estabelecidas
                  nestes Termos. O Cliente deverá pagar todos e quaisquer
                  custos, danos e despesas, incluindo, sem limitação, honorários
                  de advogados e despesas imputadas, ou incorridas pela Empresa
                  em ligação com, ou resultantes de qualquer reclamação,
                  processo legal, acção, demanda ou outro processo.
                </p>

                <h6 className={termTitleClass}>
                  14. Término e Cancelamento dos Serviços; Direito de revogação
                </h6>
                <p className="terms-para">
                  Após confirmar a aceitação do pagamento do serviço, o
                  utilizador poderá aceder ou visualizar todos os produtos que
                  estejam disponíveis dentro da serviço que subscreveu.
                </p>
                <p className="terms-para">
                  O serviço permanecerá activo até que o próprio utilizador
                  solicite o cancelamento do mesmo. Poderá fazê-lo de forma
                  gratuita em qualquer momento bastando para isso utilizar
                  qualquer uma das ferramentas disponíveis para o efeito:
                </p>
                <p className="terms-para">
                  Poderá Cancelar a subscrição ao serviço enviando "SAIR" para o
                  62962.
                </p>
                <p className="terms-para">
                  Através do serviço de apoio ao cliente:
                </p>
                <p className="terms-para">
                  Horário de atendimento telefónico: dias úteis (excepto
                  feriados) das 09h00 às 18h00.
                </p>
                <p className="terms-para">Linha de Apoio ao Cliente:</p>
                <p className="terms-para">
                  Videoflux – 707 450 201 pt@content-clubs.com
                </p>
                <p className="terms-para">
                  O Cliente concorda que a Empresa, em sigilo absoluto, poderá,
                  em qualquer altura, cancelar a sua utilização dos Serviços,
                  removendo e descartando-se de quaisquer conteúdos dentro
                  desses Serviços, (1) se a Empresa acreditar que o Cliente
                  violou ou agiu de forma inconsistente com estes Termos; (2) se
                  o Cliente não pagar os custos dentro do período estabelecido
                  na sua subscrição de telemóvel com o seu operador; (3) caso
                  seja expressamente requerido à Empresa, pelo operador, que o
                  faça ou (4) se quaisquer leis, regulamentações, directivas ou
                  acção governamental torne toda, ou qualquer parte dos Serviços
                  ilegal ou impraticável. O Cliente concorda que a Empresa não
                  será responsabilizada pelo Cliente ou qualquer terceiro, por
                  qualquer rescisão do seu acesso aos Serviços. Se o Cliente
                  cancelar a sua conta ou subscrição por qualquer motivo, a
                  Empresa não reembolsará qualquer uma das suas taxas pagas até
                  à data, excepto o explicitamente disposto em qualquer uma das
                  provisões dos presentes Termos.
                </p>
                <p className="terms-para">
                  Os Clientes da União Europeia e noutros países, poderão também
                  possuir o direito estatutário de revogar o acordo, dentro de
                  um termo mínimo de sete dias úteis após a data efectiva do
                  acordo (o ‘Período de Revogação’). A Empresa estabeleceu um
                  período de catorze dias úteis como o Período de Revogação,
                  desde que, porém, o seu direito de revogação termine
                  imediatamente, caso o acesso aos Serviços tiver sido fornecido
                  ao cliente antes do final do Período de Revogação. Para
                  revogar o acordo dentro do Período de Revogação, envie uma
                  notificação de término por e-mail, para pt@content-clubs.com,
                  ou por correio normal para Van Diemenstraat 356 - 1013CR
                  Amsterdam. Este comunicado deverá indicar claramente o seu
                  nome, morada e número de telefone, e ter a data de carimbo dos
                  correios dentro do Período de Revogação.
                </p>

                <h6 className={termTitleClass}>15. Provisões Diversas</h6>
                <p className="terms-para">
                  Avisos e Anúncios. Salvo expressamente em contrário, todas as
                  notificações enviadas para a Empresa, deverão ser efectuadas
                  por escrito e entregues na morada seguinte: . Ao aceder ou
                  utilizar os Serviços, ou enviar SMS, e-mails ou outras
                  comunicações semelhantes para a Empresa, o Cliente está a
                  comunicar connosco electronicamente, consentindo assim a
                  recepção de comunicações electrónicas por parte da Empresa. O
                  Cliente concorda que todos os acordos, notificações,
                  divulgações e outras comunicações que lhe sejam fornecidas
                  pela Empresa, satisfazem quaisquer exigências legais ou
                  contratuais que tais comunicações sejam feitas por escrito.
                  Excepto como estipulado na Secção Término e Cancelamento dos
                  Serviços; Direito de revogação, as notificações enviadas por
                  correio serão consideradas como recebidas num prazo de sete
                  dias após terem sido enviadas. As notificações publicadas no
                  website da Empresa, ou enviadas por e-mail ou SMS, serão
                  consideradas recebidas no dia útil a seguir ao dia em que
                  foram publicadas ou enviadas.
                </p>
                <p className="terms-para">
                  Transmissão: O Cliente não poderá ceder ou transferir de
                  qualquer outro modo, o acordo, ou qualquer um dos seus
                  direitos contratuais. A Empresa terá o direito de ceder os
                  seus direitos e obrigações decorrentes do presente acordo e
                  quaisquer créditos com base neste acordo, a um terceiro,
                  mediante notificação escrita efectuada ao Cliente, desde que
                  tal atribuição seja feita em condições não menos favoráveis
                  para o Cliente, do que aqueles que constam nestes Termos.
                </p>
                <p className="terms-para">
                  Alterações nos Termos. O Cliente reconhece e concorda que
                  estes Termos estão sujeitos a alterações por parte da Empresa
                  a qualquer momento, e que estas mudanças surtirão efeito ao
                  serem publicadas no website. Qualquer utilização dos Serviços
                  após estas publicações, constituirá prova da aceitação das
                  alterações por parte do Cliente.
                </p>
                <p className="terms-para">
                  Outros termos, acordo inteiro. Estes Termos são adicionais aos
                  termos e condições de qualquer Empresa ou terceiros,
                  aplicáveis aos Serviços, que poderão ser publicados em ligação
                  com tais Serviços (‘Termos Específicos’). Caso exista alguma
                  discrepância entre os Termos e esses Termos Específicos,
                  prevalecerão estes últimos. Estes Termos e quaisquer outros
                  termos ou documentos aqui referidos, constituem o acordo
                  integral entre o Cliente e a Empresa, relativamente ao seu uso
                  dos Serviços. O Cliente compreende e concorda que, salvo
                  quando expressamente previsto neste documento, este Acordo não
                  se destina a conferir e não confere quaisquer direitos ou
                  recursos a qualquer pessoa, que não as partes do presente
                  Acordo.
                </p>
                <p className="terms-para">
                  Divisibilidade. Se alguma parte deste Acordo for considerada
                  inválida ou inaplicável, essa porção deverá ser interpretada
                  em concordância com a lei aplicável, para que reflicta, tanto
                  quanto possível, as intenções originais das partes. As
                  parcelas restantes permanecerão em pleno vigor e efeito.
                </p>
                <p className="terms-para">
                  Renúncia. A impossibilidade da Empresa procurar qualquer
                  reivindicação ou defesa disponíveis, nos termos deste acordo,
                  não será uma renúncia de tal reclamação ou defesa. Os títulos
                  utilizados nestes Termos são apenas para conveniência e não
                  terão nenhum efeito na interpretação ou cumprimento legal das
                  condições aqui descritas.
                </p>
                <p className="terms-para">
                  Sobrevivência. Caso este contrato termine tal como se prevê,
                  as Secções destes Termos que, devido à sua natureza, foram
                  construídas de forma a sobreviver, sobreviverão à expiração ou
                  rescisão.
                </p>
                <p className="terms-para">
                  Lei regente e jurisdição. Este acordo e a utilização do
                  website e Serviços por parte do Cliente, serão regidos e
                  interpretados de acordo com as leis do país no qual os
                  Serviços estão a ser oferecidos. A aplicação da Convenção de
                  Contratos das Nações Unidas, para a Venda Internacional de
                  Mercadorias é expressamente excluída.
                </p>
              </Col>
            </Row>
          </Container>
        ) : (
          <Container fluid>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  General Terms And Conditions And Privacy Policy.
                </h6>
                <p className="terms-para">
                  The following General Terms and Conditions are applicable to
                  the products and services supplied via WAP, SMS, GPRS and 3G
                  by Sam Media Ltd., or enterprises affiliated to it,
                  (hereinafter to be referred to as “the Provider”). The
                  Provider is permitted to amend these General Terms and
                  Conditions from time to time without notice. Apart from the
                  General Terms and Conditions, any applicable and publicized
                  rules, promotional conditions, guidelines and provisions
                  pertaining to the services also apply to you and the Provider
                  upon the use of the Services (as defined herein) of the
                  Provider. All those guidelines, rules, promotional conditions
                  and provisions will be considered an inextricable part of
                  these General Terms and Conditions. By availing yourself to
                  use the Services of the Provider, you agree to be bound by
                  these General Terms and Conditions and the guidelines, rules
                  and promotional conditions.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Description Of The Provider.</h6>
                <p className="terms-para">
                  By means of WAP, SMS, GPRS and 3G services, the Provider
                  supplies its user’s access to a network of on-line sources,
                  including on-line games, text messages, rich content and
                  on-line information material which may be downloaded onto
                  mobile telephone or whatsoever devices (“Services”). The
                  General Terms and Conditions are at all times applicable to
                  all new facilities including facilities which the Provider may
                  implement as part of the Provider’s expansion, extension or
                  improvement of the present Services, including any extension
                  to new functions added by the Provider.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Availability.</h6>
                <p className="terms-para">
                  The Service is supplied as is (at the stage of development it
                  happens to be in) and the Provider accepts no liability nor
                  does it issue any guarantees or warranty in the event that
                  personal configurations, information or messages are not
                  saved, or not saved in due time, or if they are deleted or
                  incorrectly delivered. In order to subscribe to the Service,
                  you are required to have access to the Internet and/or a
                  mobile communications subscription and pay any service fees
                  associated with such access. You are required to pay all
                  expenses incurred in creating such access. You are also
                  responsible for seeing to the connection of any necessary
                  equipment, including any mobile telephone or personal computer
                  or whatever devices that may be necessary needed and are in
                  working order and suitable for use in connection with the
                  Service.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Payment.</h6>
                <p className="terms-para">
                  You have access to our on-line services free of charge. With
                  regards to the Services and the use of it, you shall pay the
                  amount corresponding to the applicable rates of the Provider
                  in force at that time and according to the rates charged by
                  your mobile operator. The charges shall be invoiced to you via
                  your mobile operator through the mobile bill you receive from
                  the mobile operator of your network. You pay the Provider all
                  national and local or other taxes, including but not
                  restricted to VAT, any taxes or levies imposed in lieu
                  thereof, which taxes are based on the costs due to the use of
                  the Services, regardless of whether those taxes are levied
                  either now or in the future by European, national or local
                  authorities or by any other body or bodies authorized to levy
                  taxes. The Provider reserves the right to change the rates for
                  the Service by posting details of such changes on its website.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">Registration Obligation.</h6>
                <p className="terms-para">
                  In order to warrant safe and secure use of the Service, you
                  guarantee the following, in addition to paying the applicable
                  charges: (a) your personal information (hereinafter to be
                  referred to as the “Registered Information”) provided on the
                  registration form is correct, true, accurate and complete and
                  (b) you agree to ensure that the Registered Information is at
                  all times correct, up to date, true, accurate and complete. If
                  the Provider has a reasonable suspicion that the Registered
                  Information does not reflect a true state of affairs, or is
                  not accurate or complete, then the Provider is entitled to
                  suspend or terminate your account and to withhold both current
                  and future use of the Service, or any component of it. You
                  yourself are responsible for maintaining the secrecy of any
                  passwords and/or accounts issued to you by the Provider, and
                  you are fully liable for all actions carried out involving the
                  use of your password or account. You undertake at the end of
                  each session to close your account (by closing your browser)
                  and to contact the Provider if you notice or suspect that
                  unauthorized use has been made of your password or account, or
                  that security or protection is no longer guaranteed for any
                  other reason. The Provider cannot and will not be liable for
                  any damage arising from your failure to observe the
                  stipulations of this article.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">
                  Ownership Rights Of The Provider.
                </h6>
                <p className="terms-para">
                  You are aware and agree that the Service and software used in
                  connection with the Service, (hereinafter to be referred to as
                  the “Software”), contain confidential information which
                  belongs to the Provider is protected by valid and applicable
                  intellectual and industrial ownership rights legislation and
                  other legislation. You are also aware and agree that
                  copyright, trademarks, service marks, patents or other
                  ownership rights and laws are applicable to Information
                  published in sponsors' advertisements or information offered
                  to you via the Service. You undertake, either partially or
                  wholly, not to amend, rent, rent out, borrow, lend, sell,
                  distribute or create products derived from the Service or the
                  Software except in the event that the Provider has given you
                  explicit written permission to do so. The Provider hereby
                  grants you a personal, non-transferable and non-exclusive
                  right and permission to use the working code of its Software,
                  provided you do not copy or alter any source code whatever, or
                  create a product derived from it, or carry out any reverse
                  engineering or reverse assembly on it or in any other way
                  attempt to find a source code (or permit third parties to do
                  so) (except if and insofar as such acts are permitted by the
                  provisions of any mandatory law that may be in effect), and
                  you agree not sell, encode, sublicense, encumber with security
                  rights or transfer in any other way any rights connected with
                  the Software to any person or entity. You undertake not to
                  alter the Software in any way whatever or to use any altered
                  versions of the Software for the purpose of gaining
                  unauthorized access to the Service or for any other reason. In
                  gaining access to the Service, you undertake only to make use
                  of the interface supplied for that purpose by the Provider.
                  The Provider hereby grants you permission to make one copy
                  only of the Information on the equipment you use for gaining
                  access to the Service, and to use and display the copy of the
                  Information made on that equipment for private purposes.
                </p>
              </Col>
            </Row>
          </Container>
        )}
      </section>
    );
  }

  render() {
    switch (this.state.type) {
      case "about": {
        return this.__getAboutUsPage();
      }
      case "privacy-policy": {
        return this.__getPrivacyPolicy();
      }
      case "terms-conditions": {
        return this.__getTermsConditions();
      }
      default:
        return <section></section>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      setHeaderTitle,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StaticPages);



// WEBPACK FOOTER //
// ./src/components/StaticPages/StaticPages.js